import * as actionType from "./constants";
const initialState = {
    loginUser: {},
    loginUserPython: {},
    logoutUser: {},
    forgotPassword: {},
    resetPassword: {},
    validateTokenResponse: {},
    cognitoOtpResponse: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.LOGIN_REQUEST:
            return {
                ...state
            };
        case actionType.LOGIN_SUCCESS:
            return {
                ...state,
                loginUser: { success: true, ...action.response }
            };
        case actionType.LOGIN_FAILURE:
            return {
                ...state,
                loginUser: { success: false, ...action.error }
            };
        case actionType.LOGIN_PASSWORD_RESET:
            return {
                ...state,
                loginUser: { success: false, ...action.reset }
            };
        case actionType.LOGIN_REQUEST_PYTHON:
            return {
                ...state
            };
        case actionType.LOGIN_SUCCESS_PYTHON:
            return {
                ...state,
                loginUserPython: { success: true, ...action.response }
            };
        case actionType.LOGIN_FAILURE_PYTHON:
            return {
                ...state,
                loginUserPython: { success: false, error: action.error }
            };

        case actionType.LOGOUT_REQUEST:
            return {
                ...state
            };
        case actionType.LOGOUT_SUCCESS:
            return {
                ...state,
                logoutUser: { success: true, ...action.response }
            };
        case actionType.LOGOUT_FAILURE:
            return {
                ...state,
                logoutUser: { success: false, ...action.error }
            };
        case actionType.FORGOT_PASSWORD_REQUEST:
            return {
                ...state
            };
        case actionType.FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                forgotPassword: { success: true, ...action.response }
            };
        case actionType.FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                forgotPassword: { success: false, ...action.error }
            };
        case actionType.RESET_PASSWORD_REQUEST:
            return {
                ...state
            };
        case actionType.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPassword: { success: true, ...action.response }
            };
        case actionType.RESET_PASSWORD_FAILURE:
            return {
                ...state,
                resetPassword: { success: false, ...action.error }
            };
        case actionType.VALIDATE_TOKEN_REQUEST:
            return {
                ...state
            };
        case actionType.VALIDATE_TOKEN_SUCCESS:
            return {
                ...state,
                validateTokenResponse: { success: true, ...action.response }
            };
        case actionType.VALIDATE_TOKEN_FAILURE:
            return {
                ...state,
                validateTokenResponse: { success: false, ...action.error }
            };
        case actionType.COGNITO_LOGIN_OTP_REQUEST:
            return {
                ...state
            };
        case actionType.COGNITO_LOGIN_OTP_SUCCESS:
            return {
                ...state,
                cognitoOtpResponse: { success: true, ...action.response }
            };
        case actionType.COGNITO_LOGIN_OTP_FAILURE:
            return {
                ...state,
                cognitoOtpResponse: { success: false, ...action.error }
            };

        case actionType.SSO_LOGIN_REQUEST:
            return {
                ...state
            };
        case actionType.SSO_LOGIN_SUCCESS:
            return {
                ...state,
                loginUserPython: { success: true, ...action.response }
            };
        case actionType.SSO_LOGIN_FAILURE:
            return {
                ...state,
                loginUserPython: { success: false, error: action.error }
            };

        case actionType.RESOLVE_TENANT_REQUEST:
            return {
                ...state,
                resolveTenant: { loading: true }
            };
        case actionType.RESOLVE_TENANT_SUCCESS:
            return {
                ...state,
                resolveTenant: { success: true, ...action.response, loading: false }
            };
        case actionType.RESOLVE_TENANT_FAILURE:
            return {
                ...state,
                resolveTenant: { success: false, error: action.error, loading: false }
            };

        default:
            return state;
    }
};
